import emptySplitApi from "../utils/rtk";
import { User } from "../types/User";
import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
  status: number;
  message: string;
  file_urls?: string;
};

type CountBody = {
  user_role: number;
};

export const registrationApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    postLogIn: builder.mutation<
      CommonResponseType & { data: User },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.login,
        method: "POST",
        body,
      }),
    }),
    getCustomerList: builder.query<
      CommonResponseType & { data: any },
      { body: any }
    >({
      query: ({ body }) => ({
        url: END_POINTS.customerList,
        method: "POST",
        body,
      }),
    }),
    getVendorList: builder.query<
      CommonResponseType & { data: any },
      { body: any }
    >({
      query: ({ body }) => ({
        url: END_POINTS.vendorList,
        method: "POST",
        body,
      }),
    }),
    updateApprovalStatus: builder.mutation<
      CommonResponseType & { data: any },
      { id: string; profile_status: string }
    >({
      query: ({ id, profile_status }) => ({
        url: `${END_POINTS.userApprovalStatus}/${id}/`,
        method: "PUT",
        body: { profile_status },
      }),
    }),
    getCustomerById: builder.mutation<
      CommonResponseType & { data: any },
      { id: string; profile_status: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.customerByiD}/${id}/`,
        method: "GET",
      }),
    }),

    CustomerById: builder.mutation<
      CommonResponseType & { data: any },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.customerById}/${id}/`,
        method: "GET",
        // body: { profile_status },
      }),
    }),
    deleteCustomer: builder.mutation<
      CommonResponseType & { data: any },
      { id: string; profile_status: string }
    >({
      query: ({ id, profile_status }) => ({
        url: `${END_POINTS.deleteCustomer}/${id}/`,
        method: "DELETE",
        body: { profile_status },
      }),
    }),
    deleteVendor: builder.mutation<
      CommonResponseType & { data: any },
      { id: string; profile_status: string }
    >({
      query: ({ id, profile_status }) => ({
        url: `${END_POINTS.deleteVendor}/${id}/`,
        method: "DELETE",
        body: { profile_status },
      }),
    }),

    updateVendorApprovalStatus: builder.mutation<
      CommonResponseType & { data: any },
      { id: string; profile_status: string }
    >({
      query: ({ id, profile_status }) => ({
        url: `${END_POINTS.vendorApprovalStatus}${id}/`,
        method: "PUT",
        body: { profile_status },
      }),
    }),
    updateVendorByOId: builder.mutation<
      CommonResponseType & { data: any },
      { id: string; body: any }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.updateVendor}/${id}/`,
        method: "PUT",
        body,
      }),
    }),
    GetCustomerByIdApi: builder.mutation<
      CommonResponseType & { data: any },
      { id: any }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.customerById}/${id}/`,
        method: "GET",
        // body: { profile_status },
      }),
    }),
    updateUserById: builder.mutation<
      CommonResponseType & { data: any },
      { id: string; body: any }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.updateUser}/${id}/`,
        method: "PUT",
        body,
      }),
    }),
    getVendorProfileById: builder.mutation<
      CommonResponseType & { data: any },
      { id: string | any }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.vendorById}/${id}/`,
        method: "GET",
      }),
    }),
    PutChangeUserStatus: builder.mutation<
      CommonResponseType & { data: any },
      { id: string; is_active: any }
    >({
      query: ({ id, is_active }) => ({
        url: `${END_POINTS.changeUserStatus}${id}/`,
        method: "PUT",
        body: { is_active },
      }),
    }),
    getUserCsv: builder.query<CommonResponseType & { data: any }, {}>({
      query: () => ({
        url: END_POINTS.userCsv,
        method: "POST",
      }),
    }),
    PostVendorCsv: builder.query<CommonResponseType & { data: any }, {}>({
      query: () => ({
        url: END_POINTS.VendorCsv,
        method: "POST",
      }),
    }),
    getAllCount: builder.mutation<
      CommonResponseType & { data: any },
      CountBody
    >({
      query: (body) => ({
        url: END_POINTS.getAllCount,
        method: "POST",
        body,
      }),
    }),

    documentStatus: builder.mutation<
      CommonResponseType & { data: any },
      { body: { business_verified: number }; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.documentStatus}${id}/`,
        method: "POST",
        body,
      }),
    }),
    PutChangeProductStatus: builder.mutation<
      CommonResponseType & { data: any },
      { id: any | number | string; is_active: any }
    >({
      query: ({ id, is_active }) => ({
        url: `${END_POINTS.editProduct}${id}/`,
        method: "PUT",
        body: { is_active },
      }),
    }),
  }),
});

export const {
  useLazyGetCustomerListQuery,
  useDeleteCustomerMutation,
  useGetCustomerByIdMutation,
  useDeleteVendorMutation,
  useLazyGetVendorListQuery,
  useCustomerByIdMutation,
  useUpdateApprovalStatusMutation,
  useUpdateVendorApprovalStatusMutation,
  useUpdateVendorByOIdMutation,
  useGetVendorProfileByIdMutation,
  usePutChangeUserStatusMutation,
  useUpdateUserByIdMutation,
  useGetAllCountMutation,
  useGetCustomerByIdApiMutation,
  useLazyGetUserCsvQuery,
  useLazyPostVendorCsvQuery,
  useDocumentStatusMutation,
  usePutChangeProductStatusMutation,
} = registrationApi;
